function cssVar(name: string): string {
  if (typeof window === "undefined") return "";
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
}

export const palette = {
  cat(): string[] {
    return [1, 2, 3, 4, 5, 6, 7].map((i) => cssVar(`--cat-${i}`));
  },
  ramp(): string[] {
    return ["p-50", "p-100", "p-200", "p-300", "p-400", "p-500", "p-600", "p-700"].map((tok) =>
      cssVar(`--${tok}`),
    );
  },
  status(): { todo: string; ok: string; rej: string; exp: string } {
    return {
      todo: cssVar("--st-todo-bg"),
      ok: cssVar("--st-ok-bg"),
      rej: cssVar("--vroom-red"),
      exp: cssVar("--st-exp-bg"),
    };
  },
  axis(): { stroke: string; text: string; grid: string } {
    return {
      stroke: cssVar("--line-strong"),
      text: cssVar("--ink-500"),
      grid: cssVar("--line"),
    };
  },
};
